import React from 'react'
import { useNotifications } from '../contexts/NotificationContext'

const TestNotifications = () => {
  const { addNotification } = useNotifications()

  const testNotifications = [
    {
      title: 'Critical Stock Alert',
      message: 'Device VM001 is critically low on stock (15%)',
      priority: 'critical',
      category: 'stockAlerts',
      deviceId: 'VM001'
    },
    {
      title: 'Device Offline',
      message: 'Device VM002 has gone offline',
      priority: 'warning',
      category: 'deviceOffline',
      deviceId: 'VM002'
    },
    {
      title: 'Low Stock Warning',
      message: 'Device VM003 is running low on stock (45%)',
      priority: 'warning',
      category: 'stockAlerts',
      deviceId: 'VM003'
    },
    {
      title: 'Device Back Online',
      message: 'Device VM002 is back online',
      priority: 'success',
      category: 'deviceOffline',
      deviceId: 'VM002'
    }
  ]

  const triggerTestNotification = (index) => {
    addNotification(testNotifications[index])
  }

  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">Test Notifications</h5>
      </div>
      <div className="card-body">
        <p className="text-muted mb-3">
          Click the buttons below to test different types of notifications:
        </p>
        <div className="d-flex flex-wrap gap-2">
          {testNotifications.map((notification, index) => (
            <button
              key={index}
              className={`btn btn-sm ${
                notification.priority === 'critical' ? 'btn-danger' :
                notification.priority === 'warning' ? 'btn-warning' :
                notification.priority === 'success' ? 'btn-success' : 'btn-info'
              }`}
              onClick={() => triggerTestNotification(index)}
            >
              <i className={`fas ${
                notification.priority === 'critical' ? 'fa-exclamation-triangle' :
                notification.priority === 'warning' ? 'fa-exclamation-circle' :
                notification.priority === 'success' ? 'fa-check-circle' : 'fa-info-circle'
              } me-1`}></i>
              {notification.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TestNotifications